import * as React from "react";
import { resourcesHelper } from "@falcon/services";

export class AllianzOnlineBadge extends React.Component<{ coverDetails?: boolean; policyView?: boolean; multiPolicyView?: boolean; }> {

    public render() {
        const { policyView, coverDetails, multiPolicyView } = this.props;

        if (resourcesHelper.THEME !== "Britannia") {
            return (
                <div className={`allianz-online-badge${coverDetails ? ' allianz-online-badge--cover-details' : ''}${policyView ? ' allianz-online-badge--policy-view' : ''}${multiPolicyView ? ' allianz-online-badge--multi-policy-view' : ''}`}>
                    <img src={`/${resourcesHelper.THEME}/img/allianz-online-badge.svg`} alt={`${resourcesHelper.PRODUCT} badge`} />
                </div>
            );
        }

        return null;
    }
}
